export function StatusDot({ active }) {
  return (
    <span className="status-wrap" data-testid="okx-status-indicator">
      <span className={active ? "status-ping active" : "status-ping"} />
      <span className={active ? "status-dot active" : "status-dot"} />
    </span>
  );
}